import { 
	LOGIN_CHECK, 
	SET_MANAGED_USER_ENTERPRISE, 
	SET_MANAGED_USER, 
	SET_USER,
	TOGGLE_MANAGED_USER_ENTERPRISE_PERMISSION
} from '../actions/types';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const defaultState = {
	loggedIn:false,
	data:false,
	loading: true,
	loginUrl: false
}

export const userReducer = (state = defaultState, action) => {
	switch(action.type){

		case `${LOGIN_CHECK}_${PENDING}`:

			return {
				...state,
				loading:true
			}

		case `${LOGIN_CHECK}_${FULFILLED}`:

			return {
				loggedIn:true,
				data: action.payload.data.user,
				loading: false
			}
		
		case `${LOGIN_CHECK}_${REJECTED}`:

			return {
				...state,
				loginUrl: action.payload.response.data.loginUrl,
				loading: false
			}

		case SET_USER:
			return {
				loggedIn: true,
				data: action.user
			}

		default:
			return state;
	}
}

const defaultManagedUserState = {
	userMap: {},
	data: {},
	isLive: false
}

export const managedUserReducer = ( state = defaultManagedUserState , action ) => {

	switch( action.type ){

		case SET_MANAGED_USER_ENTERPRISE:
			return {
				isLive: true,
				data: {
					...state.data,
					enterprise: action.enterprise,
					enterpriseId: action.enterprise._id,
				},
				userMap: action.userMap
			}

		case SET_MANAGED_USER:
			return {
				data: action.user,
				isLive: true
			}

		case TOGGLE_MANAGED_USER_ENTERPRISE_PERMISSION:
			return {
				...state,
				data: {
					...state.data,
					enterprise: {
						...state.data.enterprise,

						users: state.data.enterprise.users.map(
							_u => {
								if( _u.userId === action.userId ){
									return {
										..._u,
										permission: {
											..._u.permission,
											[action.permissionField]: !_u.permission[action.permissionField]
										}
									};
								}

								return _u;
							}
						)
					}
				}
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/user/reducers/index.js